import {
  Cell,
  CellTemplate,
  Compatible,
  isAlphaNumericKey,
  keyCodes,
  Uncertain,
  UncertainCompatible,
} from "@silevis/reactgrid";
import { ReactNode } from "react";
import { Select } from "antd";
import { Styles } from "./Style";
import { renderSelection } from "@lhd/features/Apps/utils";
import { CellCustomType } from "../../type";
import TextTooltip from "@lhd/components/TextToolTip";
import { APP_PART_TYPES } from "@lhd/features/Apps/AppForm/constants";

export class SelectCellTemplate implements CellTemplate<CellCustomType> {
  private isWrapText = false;
  constructor(_isWrapText?: boolean) {
    this.isWrapText = !!_isWrapText;
  }
  getCompatibleCell(
    uncertainCell: Uncertain<CellCustomType>,
  ): Compatible<CellCustomType> {
    const uncertainCellAs = uncertainCell as CellCustomType;
    return {
      value: NaN,
      ...uncertainCellAs,
    };
  }

  getClassName(
    cell: Compatible<CellCustomType>,
    isInEditMode: boolean,
  ): string {
    return cell.className || "";
  }

  update(
    cell: Compatible<CellCustomType>,
    cellToMerge: UncertainCompatible<CellCustomType>,
  ): Compatible<CellCustomType> {
    return this.getCompatibleCell({
      ...cell,
      ...cellToMerge,
    });
  }

  handleKeyDown(
    cell: Compatible<CellCustomType>,
    keyCode: number,
    ctrl: boolean,
    shift: boolean,
    alt: boolean,
  ): { cell: Compatible<CellCustomType>; enableEditMode: boolean } {
    if (!ctrl && !alt && isAlphaNumericKey(keyCode))
      return { cell, enableEditMode: true };
    return {
      cell,
      enableEditMode:
        keyCode === keyCodes.POINTER || keyCode === keyCodes.ENTER,
    };
  }
  render(
    cell: Compatible<CellCustomType>,
    isInEditMode: boolean,
    onCellChanged: (cell: Compatible<CellCustomType>, commit: boolean) => void,
  ): ReactNode {
    const selectionDataList = cell.selectionDataList || {};
    const appPartTypeAsKey = cell.appPart
      ?.app_part_type as keyof typeof selectionDataList;
    const options = selectionDataList[appPartTypeAsKey] || [];
    if (!isInEditMode) {
      if (this.isWrapText) {
        return <div className="whitespace-pre-line">{cell.text}</div>;
      }
      return <TextTooltip>{cell.text}</TextTooltip>;
    }

    const isSingleSelect =
      cell.appPart?.app_part_type === APP_PART_TYPES.COMPANY_LOCATION_SELECTION;

    return (
      <Styles
        onClick={(e) => {
          e.preventDefault();
        }}
        onPointerDown={(e) => e.stopPropagation()}
      >
        <Select
          open
          defaultValue={
            cell.valueSubmit !== undefined && cell.valueSubmit !== null
              ? Array.isArray(cell.valueSubmit) && isSingleSelect
                ? cell.valueSubmit[0]
                : cell.valueSubmit
              : undefined
          }
          mode={isSingleSelect ? undefined : "multiple"}
          loading={!selectionDataList[appPartTypeAsKey]}
          tagRender={(props: any) =>
            options?.length ? (
              renderSelection(props, cell.appPart?.app_part_type)
            ) : (
              <div></div>
            )
          }
          filterOption={(input, option: any) =>
            (option?.children ?? "")
              .toLowerCase()
              .includes(input.trim().toLowerCase())
          }
          onChange={(values) => {
            const updatedCell = this.getCompatibleCell({
              ...cell,
              valueSubmit: values as any,
            });

            onCellChanged(updatedCell, false);
          }}
        >
          {options.map((option, i) => {
            const name =
              cell.appPart?.app_part_type === APP_PART_TYPES.WORKER_SELECTION ||
              cell.appPart?.app_part_type ===
                APP_PART_TYPES.REPRESENTATIVE_SELECTION
                ? option.first_name && option.last_name
                  ? `${option.first_name} ${option.last_name}`
                  : option.name || option.full_name
                : option.name || option.full_name;

            return (
              <Select.Option
                key={i}
                value={option.id}
                className="custom-option"
              >
                {name}
              </Select.Option>
            );
          })}
        </Select>
      </Styles>
    );
  }
}
